module.exports = __webpack_public_path__ + "static/img/logo.eadd943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head/logo.png
// module id = /ssr
// module chunks = 7